import { Item } from "./ItemTypes";

export const items: Item[] = [
  {
    icon: {
      classNames: "fa-solid fa-location-dot",
    },
    link: {
      href: "https://www.google.com/maps?q=Степанівка,+Сумська+область,+Сумський+район",
      text: "Stepanivka, Sumy region, Ukraine",
    },
  },
  {
    icon: {
      classNames: "fa-solid fa-envelope",
    },
    link: {
      href: "mailto:rozgon.margarita08@gmail.com",
      text: "rozgon.margarita08@gmail.com",
    },
  },
  {
    icon: {
      classNames: "fa-solid fa-phone",
    },
    link: {
      href: "tel:+380990296250",
      text: "+380990296250",
    },
  },
  {
    icon: {
      classNames: "fa-brands fa-linkedin",
    },
    link: {
      href: "https://www.linkedin.com/in/marharyta08",
      text: "LinkedIn",
    },
  },
  {
    icon: {
      classNames: "fa-brands fa-github",
    },
    link: {
      href: "https://github.com/marharita08",
      text: "GitHub",
    },
  },
  {
    icon: {
      classNames: "fa-brands fa-telegram",
    },
    link: {
      href: "https://t.me/Marharyta_Rozghon",
      text: "Telegram",
    },
  },
];
